type Props = {
  title: string
  preCheckout: string
  continueShoppingLabel: string
  clearLabel: string
  toLocalizedPath: (path: string) => string
  clearDisabled: boolean
  onClear: () => void
}

export const CartPageHeader = ({
  title,
  preCheckout,
  continueShoppingLabel,
  clearLabel,
  toLocalizedPath,
  clearDisabled,
  onClear,
}: Props) => (
  <header className="flex flex-wrap items-center justify-between gap-3">
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{preCheckout}</p>
      <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
    </div>
    <div className="flex flex-wrap items-center gap-2">
      <a
        href={toLocalizedPath('/')}
        className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-400 hover:text-slate-900"
      >
        {continueShoppingLabel}
      </a>
      <button
        type="button"
        onClick={onClear}
        disabled={clearDisabled}
        className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700 shadow-sm transition hover:border-rose-300 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {clearLabel}
      </button>
    </div>
  </header>
)
